import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { listTickets, updateTicket } from "../adminApi";

const STATUSES = ["Open", "In Progress", "Resolved", "Closed"];

export default function AdminSupport() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => { setLoading(true); try { setItems(await listTickets()); } catch { toast.error("Failed to load."); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { try { await updateTicket(id, status); toast.success("Updated."); load(); } catch { toast.error("Update failed."); } };
  return (
    <div data-testid="admin-support">
      <h1 className="mb-1 text-2xl font-bold text-slate-900">Support Tickets</h1>
      <p className="mb-6 text-sm text-slate-500">Student support requests.</p>
      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div> : items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white py-14 text-center text-slate-400">No tickets yet.</div>
      ) : (
        <div className="space-y-3">{items.map((t) => (
          <div key={t.id} className="rounded-xl border border-slate-200 bg-white p-5">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div><div className="font-semibold text-slate-900">{t.subject}</div><div className="mt-1 text-sm text-slate-600">{t.message}</div><div className="mt-1 text-xs text-slate-400">{t.studentEmail}</div></div>
              <select value={t.status} onChange={(e) => setStatus(t.id, e.target.value)} data-testid="ticket-status" className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm outline-none focus:border-orange">
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
        ))}</div>
      )}
    </div>
  );
}
